/**
 * Toggles the visibility of elements based on their data attributes.
 * The function attaches click event listeners to buttons that have a 'data-toggle' attribute.
 * On button click, the corresponding target element's visibility is toggled by adding/removing the 'is-hidden' class.
 */
function toggleVisibility() {
  // Select all buttons with the 'data-toggle' attribute
  const buttons = document.querySelectorAll('[data-toggle]');

  // Iterate over each button
  buttons.forEach(button => {
    // Get the target element ID from the button's 'data-toggle' attribute
    const targetId = button.getAttribute('data-toggle');
    // Find the target element by ID
    const targetElement = document.getElementById(targetId);

    // Attach a click event listener to the button
    button.addEventListener('click', (event) => {
      // Prevent the click event from bubbling up to the document
      event.stopPropagation();

      // Toggle the 'is-hidden' class on the target element
      targetElement.classList.toggle('is-hidden');

      if (targetId === 'header-main-menu') {
        button.classList.toggle('active');
        document.body.style.overflow = targetElement.classList.contains('is-hidden') ? 'auto' : 'hidden';
      }
    });

    // Attach a click event listener to the document to close the element when clicking outside
    if (targetId === 'header-main-menu' || targetId === 'mobile-search') {
      document.addEventListener('click', (event) => {
        event.stopPropagation();
        // Check if the click is outside the target element and the button
        if (!targetElement.contains(event.target) && event.target !== button) {
          // Hide the target element
          targetElement.classList.add('is-hidden');

          if (targetElement.classList.contains('is-hidden')) {
            if (targetId === 'header-main-menu') {
              document.body.style.overflow = 'auto';
            }
            button.classList.remove('active');
          } else {
            if (targetId === 'header-main-menu') {
              document.body.style.overflow = 'hidden';
            }
            button.classList.add('active');
          }
        }
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  toggleVisibility();

  // We set readonly attribute to the live search input field to prevent autofocusing on it
  // Remove the readonly attribute from the live search input field after 3 seconds
  // liveSearchInput = document.querySelectorAll('.live-search .form-field-input');
  // window.addEventListener('load', () => {
  //   setTimeout(() => {
  //     liveSearchInput.forEach((input) => {
  //       input.removeAttribute('readonly');
  //     });
  //   }, 2000);
  // });

  const navmenuButtons = document.querySelectorAll('.site-navigation .navmenu.navmenu-depth-1 > *');
  const headerMainMenu = document.getElementById('header-main-menu');

  if (navmenuButtons.length) {
    navmenuButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        headerMainMenu.classList.add('is-hidden');
        document.querySelectorAll('.site-header-menu-toggle').forEach(button => {
          button.classList.remove('active');
        })
      }, true);
    });
  }
});